var sb = require('@sb/util')
import store from '@sb/store'

var g_pub = new sb.Pubsub()
setInterval(() => {
	g_pub.publish('time')
}, 20 * 1000)

export default {
	name: 'Time',
	props: ['ago', 'uppercase', 'time', 'tzoffset'],
	data () {
		return {
			t: '', // current time
			timeSub: '',
			langCode: 'en_US',
		}
	},

	methods: {
		updateTime () {
			var t = ''
			if (this.ago) {
				if (this.time > 0) t = sb.agoTime(this.time, this.langCode)
				else t = ''
			} else t = sb.shortTime(this.time, this.tzoffset)

			if (this.uppercase) t = t.toUpperCase()

			if (t === this.t) return
			this.t = t
		},
	},

	mounted () {
		this.langCode = store.i18n.locale
		this.timesub = g_pub.on('time', () => this.updateTime())
		this.updateTime()
	},

	destroyed () {
		g_pub.un(this.timesub)
	},

	render () {
		return <span>{this.t}</span>
	},
}
